import { useParams } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { AcceptInvitationPage } from './AcceptInvitationPage';

export function AcceptInvitationRoute(): ReactElement {
    const { otp } = useParams({ from: '/split-hero-layout/accept-invitation/$otp' });
    return <AcceptInvitationPage otp={otp} />;
}
